// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UberSyncUI_view__AJC-t {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-sizing: border-box;
}

.UberSyncUI_header__vi7v2 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.UberSyncUI_loader__5RBl- {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1 1;
  padding: 2.5rem;
}

/* Grid Layout */

.UberSyncUI_cardGrid__-0mN2 {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 1.25rem;
  flex: 1 1;
  overflow: hidden;
  min-height: 0;
  align-items: stretch;
}

.UberSyncUI_leftPanel__BrhaJ {
  background: #fff;
  padding: 1.25rem;
  border-radius: 0.5rem;
  box-shadow: 0 0.125rem 0.5rem rgba(0, 0, 0, 0.05);
  border: 1px solid #f0f0f0;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  height: 100%;
  min-height: 0;
  box-sizing: border-box;
}

.UberSyncUI_rightPanelWrapper__7y-35 {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  height: 100%;
  min-height: 0;
  overflow: hidden;
  box-sizing: border-box;
}

.UberSyncUI_rightPanel__VP5cY {
  display: grid;
  grid-template-rows: 1fr 1fr;
  gap: 1rem;
  flex: 1 1;
  min-height: 0;
  overflow: hidden;
  box-sizing: border-box;
}

.UberSyncUI_syncBtnContainer__7rnH1 {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.UberSyncUI_lastSyncText__9eFa1 {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  font-size: 0.75rem;
  margin-top: 0.25rem;
}

.UberSyncUI_previewPanel__nTMVO {
  background: #fff;
  padding: 1.25rem;
  border-radius: 0.5rem;
  box-shadow: 0 0.125rem 0.5rem rgba(0, 0, 0, 0.05);
  border: 1px solid #f0f0f0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 100%;
  min-height: 0;
  box-sizing: border-box;
}

.UberSyncUI_conflictPanel__3QrTe {
  background: #fff;
  padding: 1.25rem;
  border-radius: 0.5rem;
  box-shadow: 0 0.125rem 0.5rem rgba(0, 0, 0, 0.05);
  border: 1px solid #f0f0f0;
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  box-sizing: border-box;
}

.UberSyncUI_titleArea__P89Vq {
  font-size: 0.875rem;
  font-weight: 700;
  color: #262626;
  margin-bottom: 0.75rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #f0f0f0;
  padding-bottom: 0.5rem;
  flex-shrink: 0;
}

.UberSyncUI_titleText__bZXPA {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

/* Warnings and Alerts Styling */

.UberSyncUI_exclusionsContainer__\\+4or0 {
  overflow-y: auto;
  padding-right: 0.25rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  flex: 1 1;
}

.UberSyncUI_exclusionItem__Yqj4b {
  background: #fff2e8;
  border: 1px solid #ffbb96;
  border-radius: 0.375rem;
  padding: 0.625rem;
}

.UberSyncUI_exclusionReason__OGQT8 {
  font-size: 0.75rem;
  color: #fa541c;
  margin-top: 0.125rem;
}

.UberSyncUI_tabTitle__0Gsds {
  font-size: 0.8125rem;
  font-weight: 500;
}

/* Sync Logs UI */

.UberSyncUI_logsList__w57c6 {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  max-height: 20rem;
  overflow-y: auto;
  padding: 0.5rem 0.25rem;
}

.UberSyncUI_logItem__jDUN- {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.625rem 0.875rem;
  border-radius: 0.375rem;
  background: #f5f5f5;
  border: 1px solid #e8e8e8;
}

.UberSyncUI_logStoreName__K-RAP {
  font-weight: 600;
  font-size: 0.8125rem;
  color: #262626;
}

.UberSyncUI_logStoreId__TR2pW {
  font-size: 0.6875rem;
  color: #8c8c8c;
  margin-top: 0.125rem;
}

.UberSyncUI_logStatusArea__138B9 {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.UberSyncUI_logStatusText__Xc74U {
  font-size: 0.75rem;
  font-weight: 500;
}

.UberSyncUI_statusSuccess__MsSxT {
  color: #52c41a;
}

.UberSyncUI_statusError__UkUAb {
  color: #ff4d4f;
}

.UberSyncUI_statusPending__r6-Sn {
  color: #faad14;
}

.UberSyncUI_statusSyncing__c2Z0x {
  color: #1890ff;
}

.UberSyncUI_tableWrapper__d5Gdv {
  margin-bottom: 1.25rem;
}

.UberSyncUI_tabContainer__aW0t8 {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  min-height: 0;
  overflow: hidden;
}

.UberSyncUI_tabPaneWrapper__aaSRD {
  overflow: hidden;
  height: 100%;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.UberSyncUI_tabContainer__aW0t8 .ant-tabs-content-holder {
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.UberSyncUI_tabContainer__aW0t8 .ant-tabs-content {
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.UberSyncUI_tabContainer__aW0t8 .ant-tabs-tabpane {
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.UberSyncUI_tabContainer__aW0t8 .ant-tabs-nav-operations {
  display: none !important;
}

.UberSyncUI_tabContainer__aW0t8 .ant-tabs-nav-wrap {
  overflow: visible !important;
}

.UberSyncUI_tabContainer__aW0t8 .ant-tabs-tab {
  visibility: visible !important;
  opacity: 1 !important;
}

.UberSyncUI_warningIconColor__0mlOH {
  color: #fa541c;
  font-size: 1rem;
  margin-top: 0.125rem;
}

.UberSyncUI_skuText__x0Uy7 {
  font-size: 0.6875rem;
}

.UberSyncUI_infoIconError__\\+vhl2 {
  color: #ff4d4f;
  cursor: pointer;
}

.UberSyncUI_spinnerContainer__Y63lE {
  text-align: center;
  padding: 2.5rem 0;
}

.UberSyncUI_tabTitleWarning__x9cGt {
  color: #fa541c !important;
}

.UberSyncUI_warningIconTitleColor__WbDiy {
  color: #fa541c;
}

/* Row Highlights for the Comparison Table */

.UberSyncUI_tableRowAddition__5-Ota {
  background-color: #f6ffed !important;
}

.UberSyncUI_tableRowDeletion__ILQ7J {
  background-color: #fff1f0 !important;
}

.UberSyncUI_tableRowPriceDiff__VkG3l {
  background-color: #fffbe6 !important;
}

/* Menu Comparison Drawer Layout Styles (rem-based) */

.UberSyncUI_drawerContainer__E6lWH {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  gap: 1.25rem;
  min-height: 0;
}

.UberSyncUI_summaryContainer__rULyp {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
}

.UberSyncUI_diffSummaryCard__-Flkk {
  background: #fff;
  border-radius: 0.5rem;
  padding: 0.75rem 1rem;
  box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.05);
  border: 1px solid #f0f0f0;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex: 1 1;
}

.UberSyncUI_diffSummaryIcon__-u-Za {
  font-size: 1.5rem;
  padding: 0.5rem;
  border-radius: 0.5rem;
  display: flex;
}

.UberSyncUI_diffSummaryTitle__kICPs {
  font-size: 0.6875rem;
  color: #8c8c8c;
  text-transform: uppercase;
  font-weight: 600;
}

.UberSyncUI_diffSummaryValue__5QonT {
  font-size: 1.125rem;
  font-weight: 700;
}

.UberSyncUI_filterBar__VAXW\\+ {
  background: #fff;
  padding: 1rem;
  border-radius: 0.5rem;
  border: 1px solid #f0f0f0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.75rem;
}

.UberSyncUI_filterTitle__R6X9h {
  font-weight: 600;
  font-size: 0.75rem;
  color: #595959;
}

.UberSyncUI_searchInput__3sz3L {
  width: 17.5rem;
}

.UberSyncUI_tableContainer__ZEpTa {
  flex: 1 1;
  background: #fff;
  border-radius: 0.5rem;
  border: 1px solid #f0f0f0;
  overflow: hidden;
}

/* Drawer Header Title Styling */

.UberSyncUI_drawerTitleWrapper__5S2SI {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.UberSyncUI_drawerTitleIcon__FmY14 {
  font-size: 1.25rem;
  color: #1890ff;
}

.UberSyncUI_drawerTitleIcon__FmY14.UberSyncUI_Warning__ozBQB {
  color: #fa541c;
}

.UberSyncUI_drawerTitleText__1fDYm {
  font-weight: 600;
}

/* Summary Card Variant Themes */

.UberSyncUI_diffSummaryCardSuccess__HcuNu {
  border-color: #b7eb8f;
}

.UberSyncUI_diffSummaryIconSuccess__gAE5D {
  background: #f6ffed;
  color: #52c41a;
}

.UberSyncUI_diffSummaryValueSuccess__MtUdH {
  color: #272727;
}

.UberSyncUI_diffSummaryCardError__ogd3D {
  border-color: #ffa39e;
}

.UberSyncUI_diffSummaryIconError__BTtcl {
  background: #fff1f0;
  color: #f5222d;
}

.UberSyncUI_diffSummaryValueError__WIt0O {
  color: #f5222d;
}

.UberSyncUI_diffSummaryCardWarning__HfUA2 {
  border-color: #ffe58f;
}

.UberSyncUI_diffSummaryIconWarning__cURsl {
  background: #fffbe6;
  color: #fa8c16;
}

.UberSyncUI_diffSummaryValueWarning__Vqn3b {
  color: #fa8c16;
}

.UberSyncUI_diffSummaryUnitLabel__R9WlP {
  font-size: 0.75rem;
  font-weight: 400;
  color: #595959;
}

/* Table Column Cell Custom Styles */

.UberSyncUI_tableCategoryText__yU8Go {
  font-weight: 600;
  font-size: 0.75rem;
  color: #595959;
}

.UberSyncUI_flexColumn__fiKVd {
  display: flex;
  flex-direction: column;
}

.UberSyncUI_tableProductName__k\\+\\+4r {
  font-weight: 700;
  font-size: 0.8125rem;
}

.UberSyncUI_tableEmptyPrice__JRwX0 {
  font-size: 0.75rem;
  color: #8c8c8c;
  font-style: italic;
}

.UberSyncUI_priceAdded__PnjEO {
  font-weight: 700;
  color: #52c41a;
}

.UberSyncUI_pricePriceDiff__5VJ5l {
  font-weight: 700;
  color: #fa8c16;
}

.UberSyncUI_priceNormal__gm51A {
  font-weight: 700;
  color: #262626;
}

.UberSyncUI_priceDeleted__rtnd8 {
  font-weight: 700;
  color: #f5222d;
}

/* Price Diff Cell Layout */

.UberSyncUI_priceDiffContainer__\\+zBo\\+ {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.UberSyncUI_oldPriceText__LoRsK {
  font-size: 0.6875rem;
}

.UberSyncUI_newPriceText__gEPMI {
  font-weight: 700;
  font-size: 0.75rem;
  color: #52c41a;
}

.UberSyncUI_searchIcon__7uGL6 {
  color: #bfbfbf;
}

/* Right Tree Container Scroll */

.UberSyncUI_rightTreeContainer__czvlU {
  flex: 1 1;
  overflow-y: auto;
  min-height: 0;
  padding-right: 0.25rem;
}

.UberSyncUI_tabContainer__aW0t8 .ant-tabs-tabpane-active {
  display: flex !important;
  flex-direction: column;
}

/* Responsive Media Queries */

@media (max-width: 75rem) { /* 1200px */

  .UberSyncUI_view__AJC-t {
    overflow-x: hidden;
    overflow-y: auto;
    height: auto;
    width: 100%;
  }

  .UberSyncUI_cardGrid__-0mN2 {
    grid-template-columns: 1fr;
    height: auto;
    width: 100%;
    max-width: 100%;
  }

  .UberSyncUI_leftPanel__BrhaJ {
    height: auto;
    width: 100%;
    max-width: 100%;
    overflow-x: auto;
  }

  .UberSyncUI_rightPanelWrapper__7y-35 {
    height: auto;
    width: 100%;
    max-width: 100%;
    overflow: visible;
  }

  .UberSyncUI_rightPanel__VP5cY {
    grid-template-rows: auto auto;
    height: auto;
    width: 100%;
    max-width: 100%;
    overflow: visible;
  }

  .UberSyncUI_previewPanel__nTMVO, .UberSyncUI_conflictPanel__3QrTe {
    height: auto;
    overflow: visible;
  }

  .UberSyncUI_rightTreeContainer__czvlU, .UberSyncUI_exclusionsContainer__\\+4or0 {
    height: auto;
    overflow: visible;
    max-height: none;
  }
}

@media (max-height: 50rem) { /* 800px */

  .UberSyncUI_view__AJC-t {
    overflow-x: hidden;
    overflow-y: auto;
    height: auto;
    width: 100%;
  }

  .UberSyncUI_cardGrid__-0mN2 {
    grid-template-columns: 1fr;
    height: auto;
    width: 100%;
    max-width: 100%;
  }

  .UberSyncUI_leftPanel__BrhaJ {
    height: auto;
    width: 100%;
    max-width: 100%;
    overflow-x: auto;
  }

  .UberSyncUI_rightPanelWrapper__7y-35 {
    height: auto;
    width: 100%;
    max-width: 100%;
    overflow: visible;
  }

  .UberSyncUI_rightPanel__VP5cY {
    grid-template-rows: auto auto;
    height: auto;
    width: 100%;
    max-width: 100%;
    overflow: visible;
  }

  .UberSyncUI_previewPanel__nTMVO, .UberSyncUI_conflictPanel__3QrTe {
    height: auto;
    overflow: visible;
  }

  .UberSyncUI_rightTreeContainer__czvlU, .UberSyncUI_exclusionsContainer__\\+4or0 {
    height: auto;
    overflow: visible;
    max-height: none;
  }
}

@media (max-width: 48rem) { /* 768px */

  .UberSyncUI_header__vi7v2 {
    flex-direction: column;
    align-items: stretch;
    gap: 0.75rem;
  }

  .UberSyncUI_syncBtnContainer__7rnH1 {
    width: 100%;
  }

  .UberSyncUI_filterBar__VAXW\\+ {
    flex-direction: column;
    align-items: stretch;
    gap: 0.75rem;
  }

  .UberSyncUI_searchInput__3sz3L {
    width: 100%;
  }

  .UberSyncUI_summaryContainer__rULyp {
    flex-direction: column;
    gap: 0.5rem;
  }

  .UberSyncUI_diffSummaryCard__-Flkk {
    width: 100%;
    flex: none;
  }

  .UberSyncUI_drawerContainer__E6lWH {
    height: auto;
    overflow: visible;
    flex: none;
  }

  .UberSyncUI_tableContainer__ZEpTa {
    height: auto;
    overflow: visible;
    flex: none;
  }
}

.UberSyncUI_radioScrollContainer__o0hNF {
  overflow-x: auto;
  white-space: nowrap;
  width: 100%;
  padding-bottom: 0.25rem;
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}

.UberSyncUI_radioScrollContainer__o0hNF::-webkit-scrollbar {
  display: none; /* Hide scrollbar for Chrome, Safari and Opera */
}

.UberSyncUI_filterSpace__7Rra8 {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex: 1 1;
  min-width: 0;
  width: 100%;
}

/* Product Tree Nodes Custom Layout */

.UberSyncUI_productRow__gIC1j {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0.75rem;
  border-bottom: 1px solid #f0f0f0;
  gap: 0.5rem;
}

.UberSyncUI_productNode__FJEGO {
  font-size: 0.8125rem;
}

.UberSyncUI_productPrice__D18rz {
  font-weight: 600;
  color: #262626;
  white-space: nowrap;
}

.UberSyncUI_categoryNode__2PBDv {
  font-weight: 600;
  font-size: 0.875rem;
}

.UberSyncUI_flexTag__Ml\\+zO {
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center;
  gap: 0.25rem;
}

.UberSyncUI_syncButton__UDLbT {
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center;
}





`, "",{"version":3,"sources":["webpack://./src/pages/uber-sync/styles/UberSyncUI.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAO;EACP,eAAe;AACjB;;AAEA,gBAAgB;;AAChB;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;EACZ,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,iDAAiD;EACjD,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,SAAS;EACT,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,iDAAiD;EACjD,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,iDAAiD;EACjD,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gCAAgC;EAChC,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA,gCAAgC;;AAChC;EACE,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,SAAO;AACT;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA,iBAAiB;;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,0BAA0B;EAC1B,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA,4CAA4C;;AAC5C;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA,qDAAqD;;AACrD;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,iDAAiD;EACjD,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,qBAAqB;EACrB,yBAAyB;EACzB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,gCAAgC;;AAChC;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AACA;EACE,cAAc;AAChB;;AACA;EACE,gBAAgB;AAClB;;AAEA,gCAAgC;;AAChC;EACE,qBAAqB;AACvB;;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AACA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AACA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AACA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,oCAAoC;;AACpC;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;;AACA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,2BAA2B;;AAC3B;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AACA;EACE,oBAAoB;AACtB;;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,gCAAgC;;AAChC;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA,6BAA6B;;AAC7B,4BAA4B,WAAW;;EACrC;IACE,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,0BAA0B;IAC1B,YAAY;IACZ,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,6BAA6B;IAC7B,YAAY;IACZ,WAAW;IACX,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;EAClB;AACF;;AAEA,6BAA6B,UAAU;;EACrC;IACE,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,0BAA0B;IAC1B,YAAY;IACZ,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,6BAA6B;IAC7B,YAAY;IACZ,WAAW;IACX,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;EAClB;AACF;;AAEA,4BAA4B,UAAU;;EACpC;IACE,sBAAsB;IACtB,oBAAoB;IACpB,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,iBAAiB;IACjB,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,iBAAiB;IACjB,UAAU;EACZ;AACF;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,iCAAiC;EACjC,wBAAwB,GAAG,gBAAgB;EAC3C,qBAAqB,GAAG,YAAY;AACtC;;AAEA;EACE,aAAa,EAAE,gDAAgD;AACjE;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,SAAO;EACP,YAAY;EACZ,WAAW;AACb;;AAEA,qCAAqC;;AACrC;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,uBAAuB;AACzB","sourcesContent":[".view {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  box-sizing: border-box;\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1rem;\n}\n\n.loader {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: 1;\n  padding: 2.5rem;\n}\n\n/* Grid Layout */\n.cardGrid {\n  display: grid;\n  grid-template-columns: 2fr 1fr;\n  gap: 1.25rem;\n  flex: 1;\n  overflow: hidden;\n  min-height: 0;\n  align-items: stretch;\n}\n\n.leftPanel {\n  background: #fff;\n  padding: 1.25rem;\n  border-radius: 0.5rem;\n  box-shadow: 0 0.125rem 0.5rem rgba(0, 0, 0, 0.05);\n  border: 1px solid #f0f0f0;\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n  height: 100%;\n  min-height: 0;\n  box-sizing: border-box;\n}\n\n.rightPanelWrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  height: 100%;\n  min-height: 0;\n  overflow: hidden;\n  box-sizing: border-box;\n}\n\n.rightPanel {\n  display: grid;\n  grid-template-rows: 1fr 1fr;\n  gap: 1rem;\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n  box-sizing: border-box;\n}\n\n.syncBtnContainer {\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.lastSyncText {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n  font-size: 0.75rem;\n  margin-top: 0.25rem;\n}\n\n.previewPanel {\n  background: #fff;\n  padding: 1.25rem;\n  border-radius: 0.5rem;\n  box-shadow: 0 0.125rem 0.5rem rgba(0, 0, 0, 0.05);\n  border: 1px solid #f0f0f0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  height: 100%;\n  min-height: 0;\n  box-sizing: border-box;\n}\n\n.conflictPanel {\n  background: #fff;\n  padding: 1.25rem;\n  border-radius: 0.5rem;\n  box-shadow: 0 0.125rem 0.5rem rgba(0, 0, 0, 0.05);\n  border: 1px solid #f0f0f0;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  min-height: 0;\n  box-sizing: border-box;\n}\n\n.titleArea {\n  font-size: 0.875rem;\n  font-weight: 700;\n  color: #262626;\n  margin-bottom: 0.75rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-bottom: 1px solid #f0f0f0;\n  padding-bottom: 0.5rem;\n  flex-shrink: 0;\n}\n\n.titleText {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n/* Warnings and Alerts Styling */\n.exclusionsContainer {\n  overflow-y: auto;\n  padding-right: 0.25rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  flex: 1;\n}\n\n.exclusionItem {\n  background: #fff2e8;\n  border: 1px solid #ffbb96;\n  border-radius: 0.375rem;\n  padding: 0.625rem;\n}\n\n.exclusionReason {\n  font-size: 0.75rem;\n  color: #fa541c;\n  margin-top: 0.125rem;\n}\n\n.tabTitle {\n  font-size: 0.8125rem;\n  font-weight: 500;\n}\n\n/* Sync Logs UI */\n.logsList {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  max-height: 20rem;\n  overflow-y: auto;\n  padding: 0.5rem 0.25rem;\n}\n\n.logItem {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.625rem 0.875rem;\n  border-radius: 0.375rem;\n  background: #f5f5f5;\n  border: 1px solid #e8e8e8;\n}\n\n.logStoreName {\n  font-weight: 600;\n  font-size: 0.8125rem;\n  color: #262626;\n}\n\n.logStoreId {\n  font-size: 0.6875rem;\n  color: #8c8c8c;\n  margin-top: 0.125rem;\n}\n\n.logStatusArea {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.logStatusText {\n  font-size: 0.75rem;\n  font-weight: 500;\n}\n\n.statusSuccess {\n  color: #52c41a;\n}\n\n.statusError {\n  color: #ff4d4f;\n}\n\n.statusPending {\n  color: #faad14;\n}\n\n.statusSyncing {\n  color: #1890ff;\n}\n\n.tableWrapper {\n  margin-bottom: 1.25rem;\n}\n\n.tabContainer {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.tabPaneWrapper {\n  overflow: hidden;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;  \n}\n\n.tabContainer :global(.ant-tabs-content-holder) {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.tabContainer :global(.ant-tabs-content) {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.tabContainer :global(.ant-tabs-tabpane) {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.tabContainer :global(.ant-tabs-nav-operations) {\n  display: none !important;\n}\n\n.tabContainer :global(.ant-tabs-nav-wrap) {\n  overflow: visible !important;\n}\n\n.tabContainer :global(.ant-tabs-tab) {\n  visibility: visible !important;\n  opacity: 1 !important;\n}\n\n.warningIconColor {\n  color: #fa541c;\n  font-size: 1rem;\n  margin-top: 0.125rem;\n}\n\n.skuText {\n  font-size: 0.6875rem;\n}\n\n.infoIconError {\n  color: #ff4d4f;\n  cursor: pointer;\n}\n\n.spinnerContainer {\n  text-align: center;\n  padding: 2.5rem 0;\n}\n\n.tabTitleWarning {\n  color: #fa541c !important;\n}\n\n.warningIconTitleColor {\n  color: #fa541c;\n}\n\n/* Row Highlights for the Comparison Table */\n.tableRowAddition {\n  background-color: #f6ffed !important;\n}\n\n.tableRowDeletion {\n  background-color: #fff1f0 !important;\n}\n\n.tableRowPriceDiff {\n  background-color: #fffbe6 !important;\n}\n\n/* Menu Comparison Drawer Layout Styles (rem-based) */\n.drawerContainer {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  gap: 1.25rem;\n  min-height: 0;\n}\n\n.summaryContainer {\n  display: flex;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n.diffSummaryCard {\n  background: #fff;\n  border-radius: 0.5rem;\n  padding: 0.75rem 1rem;\n  box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.05);\n  border: 1px solid #f0f0f0;\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  flex: 1;\n}\n\n.diffSummaryIcon {\n  font-size: 1.5rem;\n  padding: 0.5rem;\n  border-radius: 0.5rem;\n  display: flex;\n}\n\n.diffSummaryTitle {\n  font-size: 0.6875rem;\n  color: #8c8c8c;\n  text-transform: uppercase;\n  font-weight: 600;\n}\n\n.diffSummaryValue {\n  font-size: 1.125rem;\n  font-weight: 700;\n}\n\n.filterBar {\n  background: #fff;\n  padding: 1rem;\n  border-radius: 0.5rem;\n  border: 1px solid #f0f0f0;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n}\n\n.filterTitle {\n  font-weight: 600;\n  font-size: 0.75rem;\n  color: #595959;\n}\n\n.searchInput {\n  width: 17.5rem;\n}\n\n.tableContainer {\n  flex: 1;\n  background: #fff;\n  border-radius: 0.5rem;\n  border: 1px solid #f0f0f0;\n  overflow: hidden;\n}\n\n/* Drawer Header Title Styling */\n.drawerTitleWrapper {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n.drawerTitleIcon {\n  font-size: 1.25rem;\n  color: #1890ff;\n}\n.drawerTitleIcon.Warning {\n  color: #fa541c;\n}\n.drawerTitleText {\n  font-weight: 600;\n}\n\n/* Summary Card Variant Themes */\n.diffSummaryCardSuccess {\n  border-color: #b7eb8f;\n}\n.diffSummaryIconSuccess {\n  background: #f6ffed;\n  color: #52c41a;\n}\n.diffSummaryValueSuccess {\n  color: #272727;\n}\n\n.diffSummaryCardError {\n  border-color: #ffa39e;\n}\n.diffSummaryIconError {\n  background: #fff1f0;\n  color: #f5222d;\n}\n.diffSummaryValueError {\n  color: #f5222d;\n}\n\n.diffSummaryCardWarning {\n  border-color: #ffe58f;\n}\n.diffSummaryIconWarning {\n  background: #fffbe6;\n  color: #fa8c16;\n}\n.diffSummaryValueWarning {\n  color: #fa8c16;\n}\n\n.diffSummaryUnitLabel {\n  font-size: 0.75rem;\n  font-weight: 400;\n  color: #595959;\n}\n\n/* Table Column Cell Custom Styles */\n.tableCategoryText {\n  font-weight: 600;\n  font-size: 0.75rem;\n  color: #595959;\n}\n.flexColumn {\n  display: flex;\n  flex-direction: column;\n}\n.tableProductName {\n  font-weight: 700;\n  font-size: 0.8125rem;\n}\n.tableEmptyPrice {\n  font-size: 0.75rem;\n  color: #8c8c8c;\n  font-style: italic;\n}\n.priceAdded {\n  font-weight: 700;\n  color: #52c41a;\n}\n.pricePriceDiff {\n  font-weight: 700;\n  color: #fa8c16;\n}\n.priceNormal {\n  font-weight: 700;\n  color: #262626;\n}\n.priceDeleted {\n  font-weight: 700;\n  color: #f5222d;\n}\n\n/* Price Diff Cell Layout */\n.priceDiffContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n}\n.oldPriceText {\n  font-size: 0.6875rem;\n}\n.newPriceText {\n  font-weight: 700;\n  font-size: 0.75rem;\n  color: #52c41a;\n}\n\n.searchIcon {\n  color: #bfbfbf;\n}\n\n/* Right Tree Container Scroll */\n.rightTreeContainer {\n  flex: 1;\n  overflow-y: auto;\n  min-height: 0;\n  padding-right: 0.25rem;\n}\n\n.tabContainer :global(.ant-tabs-tabpane-active) {\n  display: flex !important;\n  flex-direction: column;\n}\n\n/* Responsive Media Queries */\n@media (max-width: 75rem) { /* 1200px */\n  .view {\n    overflow-x: hidden;\n    overflow-y: auto;\n    height: auto;\n    width: 100%;\n  }\n  \n  .cardGrid {\n    grid-template-columns: 1fr;\n    height: auto;\n    width: 100%;\n    max-width: 100%;\n  }\n  \n  .leftPanel {\n    height: auto;\n    width: 100%;\n    max-width: 100%;\n    overflow-x: auto;\n  }\n  \n  .rightPanelWrapper {\n    height: auto;\n    width: 100%;\n    max-width: 100%;\n    overflow: visible;\n  }\n  \n  .rightPanel {\n    grid-template-rows: auto auto;\n    height: auto;\n    width: 100%;\n    max-width: 100%;\n    overflow: visible;\n  }\n  \n  .previewPanel, .conflictPanel {\n    height: auto;\n    overflow: visible;\n  }\n\n  .rightTreeContainer, .exclusionsContainer {\n    height: auto;\n    overflow: visible;\n    max-height: none;\n  }\n}\n\n@media (max-height: 50rem) { /* 800px */\n  .view {\n    overflow-x: hidden;\n    overflow-y: auto;\n    height: auto;\n    width: 100%;\n  }\n  \n  .cardGrid {\n    grid-template-columns: 1fr;\n    height: auto;\n    width: 100%;\n    max-width: 100%;\n  }\n  \n  .leftPanel {\n    height: auto;\n    width: 100%;\n    max-width: 100%;\n    overflow-x: auto;\n  }\n  \n  .rightPanelWrapper {\n    height: auto;\n    width: 100%;\n    max-width: 100%;\n    overflow: visible;\n  }\n  \n  .rightPanel {\n    grid-template-rows: auto auto;\n    height: auto;\n    width: 100%;\n    max-width: 100%;\n    overflow: visible;\n  }\n  \n  .previewPanel, .conflictPanel {\n    height: auto;\n    overflow: visible;\n  }\n\n  .rightTreeContainer, .exclusionsContainer {\n    height: auto;\n    overflow: visible;\n    max-height: none;\n  }\n}\n\n@media (max-width: 48rem) { /* 768px */\n  .header {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 0.75rem;\n  }\n  \n  .syncBtnContainer {\n    width: 100%;\n  }\n\n  .filterBar {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 0.75rem;\n  }\n  \n  .searchInput {\n    width: 100%;\n  }\n\n  .summaryContainer {\n    flex-direction: column;\n    gap: 0.5rem;\n  }\n\n  .diffSummaryCard {\n    width: 100%;\n    flex: none;\n  }\n\n  .drawerContainer {\n    height: auto;\n    overflow: visible;\n    flex: none;\n  }\n  \n  .tableContainer {\n    height: auto;\n    overflow: visible;\n    flex: none;\n  }\n}\n\n.radioScrollContainer {\n  overflow-x: auto;\n  white-space: nowrap;\n  width: 100%;\n  padding-bottom: 0.25rem;\n  -webkit-overflow-scrolling: touch;\n  -ms-overflow-style: none;  /* IE and Edge */\n  scrollbar-width: none;  /* Firefox */\n}\n\n.radioScrollContainer::-webkit-scrollbar {\n  display: none; /* Hide scrollbar for Chrome, Safari and Opera */\n}\n\n.filterSpace {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  flex: 1;\n  min-width: 0;\n  width: 100%;\n}\n\n/* Product Tree Nodes Custom Layout */\n.productRow {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.5rem 0.75rem;\n  border-bottom: 1px solid #f0f0f0;\n  gap: 0.5rem;\n}\n\n.productNode {\n  font-size: 0.8125rem;\n}\n\n.productPrice {\n  font-weight: 600;\n  color: #262626;\n  white-space: nowrap;\n}\n\n.categoryNode {\n  font-weight: 600;\n  font-size: 0.875rem;\n}\n\n.flexTag {\n  display: inline-flex !important;\n  align-items: center !important;\n  justify-content: center;\n  gap: 0.25rem;\n}\n\n.syncButton {\n  display: inline-flex !important;\n  align-items: center !important;\n  justify-content: center;\n}\n\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"view": `UberSyncUI_view__AJC-t`,
	"header": `UberSyncUI_header__vi7v2`,
	"loader": `UberSyncUI_loader__5RBl-`,
	"cardGrid": `UberSyncUI_cardGrid__-0mN2`,
	"leftPanel": `UberSyncUI_leftPanel__BrhaJ`,
	"rightPanelWrapper": `UberSyncUI_rightPanelWrapper__7y-35`,
	"rightPanel": `UberSyncUI_rightPanel__VP5cY`,
	"syncBtnContainer": `UberSyncUI_syncBtnContainer__7rnH1`,
	"lastSyncText": `UberSyncUI_lastSyncText__9eFa1`,
	"previewPanel": `UberSyncUI_previewPanel__nTMVO`,
	"conflictPanel": `UberSyncUI_conflictPanel__3QrTe`,
	"titleArea": `UberSyncUI_titleArea__P89Vq`,
	"titleText": `UberSyncUI_titleText__bZXPA`,
	"exclusionsContainer": `UberSyncUI_exclusionsContainer__+4or0`,
	"exclusionItem": `UberSyncUI_exclusionItem__Yqj4b`,
	"exclusionReason": `UberSyncUI_exclusionReason__OGQT8`,
	"tabTitle": `UberSyncUI_tabTitle__0Gsds`,
	"logsList": `UberSyncUI_logsList__w57c6`,
	"logItem": `UberSyncUI_logItem__jDUN-`,
	"logStoreName": `UberSyncUI_logStoreName__K-RAP`,
	"logStoreId": `UberSyncUI_logStoreId__TR2pW`,
	"logStatusArea": `UberSyncUI_logStatusArea__138B9`,
	"logStatusText": `UberSyncUI_logStatusText__Xc74U`,
	"statusSuccess": `UberSyncUI_statusSuccess__MsSxT`,
	"statusError": `UberSyncUI_statusError__UkUAb`,
	"statusPending": `UberSyncUI_statusPending__r6-Sn`,
	"statusSyncing": `UberSyncUI_statusSyncing__c2Z0x`,
	"tableWrapper": `UberSyncUI_tableWrapper__d5Gdv`,
	"tabContainer": `UberSyncUI_tabContainer__aW0t8`,
	"tabPaneWrapper": `UberSyncUI_tabPaneWrapper__aaSRD`,
	"warningIconColor": `UberSyncUI_warningIconColor__0mlOH`,
	"skuText": `UberSyncUI_skuText__x0Uy7`,
	"infoIconError": `UberSyncUI_infoIconError__+vhl2`,
	"spinnerContainer": `UberSyncUI_spinnerContainer__Y63lE`,
	"tabTitleWarning": `UberSyncUI_tabTitleWarning__x9cGt`,
	"warningIconTitleColor": `UberSyncUI_warningIconTitleColor__WbDiy`,
	"tableRowAddition": `UberSyncUI_tableRowAddition__5-Ota`,
	"tableRowDeletion": `UberSyncUI_tableRowDeletion__ILQ7J`,
	"tableRowPriceDiff": `UberSyncUI_tableRowPriceDiff__VkG3l`,
	"drawerContainer": `UberSyncUI_drawerContainer__E6lWH`,
	"summaryContainer": `UberSyncUI_summaryContainer__rULyp`,
	"diffSummaryCard": `UberSyncUI_diffSummaryCard__-Flkk`,
	"diffSummaryIcon": `UberSyncUI_diffSummaryIcon__-u-Za`,
	"diffSummaryTitle": `UberSyncUI_diffSummaryTitle__kICPs`,
	"diffSummaryValue": `UberSyncUI_diffSummaryValue__5QonT`,
	"filterBar": `UberSyncUI_filterBar__VAXW+`,
	"filterTitle": `UberSyncUI_filterTitle__R6X9h`,
	"searchInput": `UberSyncUI_searchInput__3sz3L`,
	"tableContainer": `UberSyncUI_tableContainer__ZEpTa`,
	"drawerTitleWrapper": `UberSyncUI_drawerTitleWrapper__5S2SI`,
	"drawerTitleIcon": `UberSyncUI_drawerTitleIcon__FmY14`,
	"Warning": `UberSyncUI_Warning__ozBQB`,
	"drawerTitleText": `UberSyncUI_drawerTitleText__1fDYm`,
	"diffSummaryCardSuccess": `UberSyncUI_diffSummaryCardSuccess__HcuNu`,
	"diffSummaryIconSuccess": `UberSyncUI_diffSummaryIconSuccess__gAE5D`,
	"diffSummaryValueSuccess": `UberSyncUI_diffSummaryValueSuccess__MtUdH`,
	"diffSummaryCardError": `UberSyncUI_diffSummaryCardError__ogd3D`,
	"diffSummaryIconError": `UberSyncUI_diffSummaryIconError__BTtcl`,
	"diffSummaryValueError": `UberSyncUI_diffSummaryValueError__WIt0O`,
	"diffSummaryCardWarning": `UberSyncUI_diffSummaryCardWarning__HfUA2`,
	"diffSummaryIconWarning": `UberSyncUI_diffSummaryIconWarning__cURsl`,
	"diffSummaryValueWarning": `UberSyncUI_diffSummaryValueWarning__Vqn3b`,
	"diffSummaryUnitLabel": `UberSyncUI_diffSummaryUnitLabel__R9WlP`,
	"tableCategoryText": `UberSyncUI_tableCategoryText__yU8Go`,
	"flexColumn": `UberSyncUI_flexColumn__fiKVd`,
	"tableProductName": `UberSyncUI_tableProductName__k++4r`,
	"tableEmptyPrice": `UberSyncUI_tableEmptyPrice__JRwX0`,
	"priceAdded": `UberSyncUI_priceAdded__PnjEO`,
	"pricePriceDiff": `UberSyncUI_pricePriceDiff__5VJ5l`,
	"priceNormal": `UberSyncUI_priceNormal__gm51A`,
	"priceDeleted": `UberSyncUI_priceDeleted__rtnd8`,
	"priceDiffContainer": `UberSyncUI_priceDiffContainer__+zBo+`,
	"oldPriceText": `UberSyncUI_oldPriceText__LoRsK`,
	"newPriceText": `UberSyncUI_newPriceText__gEPMI`,
	"searchIcon": `UberSyncUI_searchIcon__7uGL6`,
	"rightTreeContainer": `UberSyncUI_rightTreeContainer__czvlU`,
	"radioScrollContainer": `UberSyncUI_radioScrollContainer__o0hNF`,
	"filterSpace": `UberSyncUI_filterSpace__7Rra8`,
	"productRow": `UberSyncUI_productRow__gIC1j`,
	"productNode": `UberSyncUI_productNode__FJEGO`,
	"productPrice": `UberSyncUI_productPrice__D18rz`,
	"categoryNode": `UberSyncUI_categoryNode__2PBDv`,
	"flexTag": `UberSyncUI_flexTag__Ml+zO`,
	"syncButton": `UberSyncUI_syncButton__UDLbT`
};
export default ___CSS_LOADER_EXPORT___;
